import React, {useState, useEffect, useMemo} from "react";
import Modal from "./index";
import handleCopy from "../../utils/handleCopy";
import { getDateUSAFormat } from "../../utils/getUserCurrentDate";
import { detectDevice } from "../../utils/detectDevice";
import { checkCurrentMemory } from "../../utils/localStorage";
import Button from "../Button";
import formatTime from "../../utils/formatTime";
import DaysStats from "../DaysStats";
import { getUserCurrentDate } from "../../utils/getUserCurrentDate";
import createShareURL from "../../utils/createShareURL";

const congrats = [
    "YOU DID IT!",
    "NICE JOB!",
    "WELL DONE!",
    "GREAT WORK!",
    "IMPRESSIVE!",
    "AMAZING WORK!",
    "FANTASTIC!",
]
export default function ResultModal({ show, onClose, strikes, blocks, head, tail, gameStatus }) {
    
    const shuffleCelebration = () => {
        return congrats[Math.floor(Math.random() * congrats.length)];
    }

    const [textCopied, setTextCopied] = useState(false);
    const [celebrationMessage] = useState(() => shuffleCelebration());

    useEffect(() => {
        if (textCopied) {
            const timer = setTimeout(() => {
                setTextCopied(false);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [textCopied]);

    const getHeadTailName = (block) => {
        if (block.type === "MEDIA") {
            return `${block.title}`;
        }
        else {
            return `${block.name}`;
        }
    }

    const getText = () => {
        return (
`CineSnake Results for ${getDateUSAFormat()}:
${combineStikesAndBlocks()}
https://www.cinesnake.com`
        )
    }

    const getShareText = () => {
        return (
`CineSnake Results for ${getDateUSAFormat()}:
${combineStikesAndBlocks()}
Click below to see how I did and try it yourself!:
${createShareURL(blocks, head, tail, strikes)}`
        )
    }

    function combineStikesAndBlocks() {
        let result = blocks.map((b) => {
            if(b.select_count === 0){
                return "🎗️";
            }
            else if(b.hint){
                return "💡"
            }
            else{
                return "🍿"
            }
        });
        strikes.forEach(({ idx, direction, strikeInfo }) => {
            if(strikeInfo.hintUsed){
                return 
            }
            let insertIndex = direction === 'fwd' ? idx : result.length - idx;
            result.splice(insertIndex, 0, "❌");
        });

        return result.join("");
    }
    const handleShare = (full) => {
        let device = detectDevice();
        const copyText = full ? getShareText() : getText();
        const titleText = full ? 'My Cinesnake Results' : 'CineSnake Results';
        if(device === "mobile" && navigator.share){
            navigator.share({
                title: titleText,
                text: copyText,
            }).catch((error) => console.error('Error sharing', error));
        }
        else {
            handleCopy(copyText);
            setTextCopied(true);
        }
    }
    const getStreak = () => {
        return checkCurrentMemory().consecutiveWins;
    }

    const winResult = ()=>{
        return (
            <Modal show={show} onClose={onClose}>
                <h1>{celebrationMessage}</h1>
                <p>
                    You connected <strong>{getHeadTailName(head)}</strong> to <strong>{getHeadTailName(tail)}</strong> {/** `in {formattedPuzzleTime} using`*/}in {blocks.length} moves with {strikes.length} strike{strikes.length === 1 ? '':'s'}. 
                    Come back for a new puzzle tomorrow!!
                </p>
                {getStreak() > 0 && (
                    <p>
                        You have a <span style={{fontWeight:'bold'}}>{getStreak()}</span> day streak!
                    </p>
                )}
                <DaysStats blocks={blocks} head={head} tail={tail} gameStatus={gameStatus}/>
                <div style={{display:'flex', flexDirection:'column', gap:10}}>
                    <Button icon={["fas", "share"]} onClick={()=>handleShare(true)} text={textCopied ? 'Copied to Clipboard' : 'Share my score!'} />
                </div>
                <br/>
                <br/>
            </Modal>
        );
    }

    const loseResult = () => {
        return (
            <Modal show={show} onClose={onClose}>
                <h1>YOU LOST!</h1>
                <p>
                    You almost got it.
                    Come back for a new puzzle tomorrow!!
                </p>
                <p>
                    Start your streak over tomorrow!
                </p>
                <DaysStats blocks={blocks} head={head} tail={tail} gameStatus={gameStatus}/>

                <Button icon={["fas", "share"]} onClick={()=>handleShare(true)} text={textCopied ? 'Copied to Clipboard' : 'Share my score!'} />
                <br />
                <br />
            </Modal>
        );
    }
    return (
        strikes.length < 3 ? winResult() : loseResult()
    );
}